/** Spanish for the people area. Keys are the exact English strings the UI renders. */
const people = {
  // StatusBadge - the badge translates its own label, so every status key's English lives here.
  // 'Normal' is deliberately absent: it is the same word in Spanish and the dictionary test
  // rejects a value equal to its key.
  Pending: 'Pendiente',
  Submitted: 'Presentado',
  Approved: 'Aprobado',
  Shipped: 'Enviado',
  'In Transit': 'En tránsito',
  Completed: 'Completado',
  Delivered: 'Entregado',
  Cancelled: 'Cancelado',
  Rejected: 'Rechazado',
  Covered: 'Cubierto',
  'Not Covered': 'No cubierto',
  'Needs Review': 'Requiere revisión',
  Active: 'Activo',
  Inactive: 'Inactivo',
  Critical: 'Crítico',
  Urgent: 'Urgente',

  // Shared components (SearchBar, IconButton, DateRangeFilter, DeleteRecordModal) and the
  // captions other pages hand them as props.
  'Search...': 'Buscar...',
  'Search invoices...': 'Buscar facturas...',
  'Search IVR details...': 'Buscar detalles de IVR...',
  'Search orders...': 'Buscar pedidos...',
  'Search products...': 'Buscar productos...',
  'Search shipments...': 'Buscar envíos...',
  'Search by name, license...': 'Buscar por nombre, licencia...',
  'Export my orders (Excel)': 'Exportar mis pedidos (Excel)',
  'Filter by date submitted': 'Filtrar por fecha de presentación',
  'Filtered: {from} to {to}': 'Filtrado: de {from} a {to}',
  any: 'cualquier fecha',
  'Date submitted': 'Fecha de presentación',
  From: 'Desde',
  To: 'Hasta',
  Clear: 'Limpiar',
  Done: 'Listo',
  'Delete {label}?': '¿Eliminar {label}?',
  'It will be removed from lists, reports and exports. Nothing is destroyed — an admin can restore it.':
    'Se quitará de las listas, los informes y las exportaciones. No se destruye nada: un administrador puede restaurarlo.',
  'Delete failed': 'No se pudo eliminar',
  Cancel: 'Cancelar',
  Delete: 'Eliminar',
  'Delete anyway': 'Eliminar de todos modos',
  'Deleting...': 'Eliminando...',
  Close: 'Cerrar',
  'Loading...': 'Cargando...',
  Previous: 'Anterior',
  Next: 'Siguiente',
  'Page {page} of {total}': 'Página {page} de {total}',
  // utils/requestError.js and services/api.js (HTTP 429)
  'Too many requests in a short time. Please wait a minute and try again.':
    'Demasiadas solicitudes en poco tiempo. Espere un minuto e inténtelo de nuevo.',

  // Users page
  Users: 'Usuarios',
  'Every login, its role, and exactly what it can see.':
    'Cada inicio de sesión, su rol y exactamente lo que puede ver.',
  '+ New User': '+ Nuevo usuario',
  '{name} can sign in now.': '{name} ya puede iniciar sesión.',
  Email: 'Correo electrónico',
  Password: 'Contraseña',
  'Copy the password now. It is not shown again.':
    'Copie la contraseña ahora. No se volverá a mostrar.',
  Dismiss: 'Descartar',
  'Search name or email...': 'Buscar por nombre o correo electrónico...',
  'Search users': 'Buscar usuarios',
  'Filter by role': 'Filtrar por rol',
  'All roles': 'Todos los roles',
  Admin: 'Administrador',
  'Sales Rep': 'Representante de ventas',
  Clinic: 'Clínica',
  Patient: 'Paciente',
  'Filter by status': 'Filtrar por estado',
  Deactivated: 'Desactivado',
  All: 'Todos',
  '{n} user': '{n} usuario',
  '{n} users': '{n} usuarios',
  '{n} need attention on this page': '{n} requieren atención en esta página',
  'Could not load users.': 'No se pudieron cargar los usuarios.',
  USER: 'USUARIO',
  EMAIL: 'CORREO ELECTRÓNICO',
  ROLE: 'ROL',
  'CAN SEE': 'PUEDE VER',
  'No users match this filter.': 'Ningún usuario coincide con este filtro.',
  '(no name)': '(sin nombre)',
  'Locked out: cannot log in, and any existing session is rejected on every request':
    'Bloqueado: no puede iniciar sesión y cualquier sesión existente se rechaza en cada solicitud',
  'Distributor admin': 'Administrador de distribuidores',
  'All distributors; no client workspace access':
    'Todos los distribuidores; sin acceso al portal de clientes',
  Everything: 'Todo',
  'No clinic bound - this login sees nothing':
    'Sin clínica vinculada: este inicio de sesión no ve nada',
  '(own submissions only)': '(solo sus propios envíos)',
  'Unknown clinic': 'Clínica desconocida',
  'No clinics assigned - sees only own submissions':
    'Sin clínicas asignadas: solo ve sus propios envíos',
  '{n} clinics': '{n} clínicas',
  'Own records only': 'Solo sus propios registros',

  // New user dialog
  'New user': 'Nuevo usuario',
  'They can sign in the moment you save, with the email and password below.':
    'Podrá iniciar sesión en cuanto guarde, con el correo electrónico y la contraseña de abajo.',
  'First name': 'Nombre',
  'Last name': 'Apellido',
  Role: 'Rol',
  'Every screen: orders, IVRs, invoicing, statements, users.':
    'Todas las pantallas: pedidos, IVR, facturación, estados de cuenta, usuarios.',
  'Submits orders and IVRs for the clinics ticked below, and sees their invoices.':
    'Envía pedidos e IVR para las clínicas marcadas abajo y ve sus facturas.',
  'A practice login: submits orders and IVRs for its own clinic and sees its invoices.':
    'Un inicio de sesión de consultorio: envía pedidos e IVR para su propia clínica y ve sus facturas.',
  'Clinic name': 'Nombre de la clínica',
  'Select a clinic...': 'Seleccione una clínica...',
  'No clinics to choose from. Run Sync from QuickBooks on the Clinics tab first.':
    'No hay clínicas para elegir. Ejecute primero Sincronizar desde QuickBooks en la pestaña Clínicas.',
  'Clinics they can see': 'Clínicas que puede ver',
  '{n} of {total} selected': '{n} de {total} seleccionadas',
  'Filter clinics...': 'Filtrar clínicas...',
  'Filter clinics': 'Filtrar clínicas',
  'Nothing matches that.': 'Nada coincide con eso.',
  'No clinics yet. Run Sync from QuickBooks on the Clinics tab first.':
    'Aún no hay clínicas. Ejecute primero Sincronizar desde QuickBooks en la pestaña Clínicas.',
  Hide: 'Ocultar',
  Show: 'Mostrar',
  '12+ characters with an uppercase letter, a lowercase letter, a number and one of @$!%*?&#':
    '12 caracteres o más, con una letra mayúscula, una minúscula, un número y uno de @$!%*?&#',
  'No clinics are ticked. This rep will sign in and see only their own submissions until an admin gives them clinics. Click Create user again to save it that way.':
    'No hay clínicas marcadas. Este representante iniciará sesión y verá solo sus propios envíos hasta que un administrador le asigne clínicas. Haga clic en Crear usuario de nuevo para guardarlo así.',
  'Creating...': 'Creando...',
  'Create user': 'Crear usuario',
  'First and last name are required.': 'El nombre y el apellido son obligatorios.',
  'Email is required.': 'El correo electrónico es obligatorio.',
  'That email address does not look right.': 'Ese correo electrónico no parece válido.',
  'Password is required.': 'La contraseña es obligatoria.',
  'Password must be at least 12 characters.': 'La contraseña debe tener al menos 12 caracteres.',
  'Password must include an uppercase letter, a lowercase letter, a number and a special character (@$!%*?&#).':
    'La contraseña debe incluir una letra mayúscula, una minúscula, un número y un carácter especial (@$!%*?&#).',
  'Pick the clinic this login belongs to.':
    'Elija la clínica a la que pertenece este inicio de sesión.',
  'Could not create the user. Nothing was saved.':
    'No se pudo crear el usuario. No se guardó nada.',
  // Server sentences behind POST /admin/users (users.service.ts, create-user.dto.ts)
  'Email already registered': 'El correo electrónico ya está registrado',
  'A clinic user must be bound to a clinic':
    'Un usuario de clínica debe estar vinculado a una clínica',
  'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&#)':
    'La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un número y un carácter especial (@$!%*?&#)',
  'User not found': 'Usuario no encontrado',
  'Clinic not found': 'Clínica no encontrada',

  // Rep access dialog
  'Filter...': 'Filtrar...',
  'Could not load access settings': 'No se pudo cargar la configuración de acceso',
  'Could not save those changes': 'No se pudieron guardar esos cambios',
  'Removed {n} account that came with {name}.': 'Se quitó {n} cuenta que venía con {name}.',
  'Removed {n} accounts that came with {name}.': 'Se quitaron {n} cuentas que venían con {name}.',
  "Added {n} of {name}'s account above. Untick any you do not want.":
    'Se agregó {n} cuenta de {name} arriba. Desmarque las que no desee.',
  "Added {n} of {name}'s accounts above. Untick any you do not want.":
    'Se agregaron {n} cuentas de {name} arriba. Desmarque las que no desee.',
  "{name}'s accounts were already selected.": 'Las cuentas de {name} ya estaban seleccionadas.',
  '{name} has no accounts yet.': '{name} aún no tiene cuentas.',
  'Unnamed clinic': 'Clínica sin nombre',
  '{name} ({n} account)': '{name} ({n} cuenta)',
  '{name} ({n} accounts)': '{name} ({n} cuentas)',
  'Access for {name}': 'Acceso de {name}',
  'Access — {name}': 'Acceso — {name}',
  "Tick the accounts and the reps this person can see. Ticking a rep also ticks that rep's accounts, which you can then adjust — what is saved is exactly what is ticked.":
    'Marque las cuentas y los representantes que esta persona puede ver. Al marcar un representante también se marcan sus cuentas, que luego puede ajustar; lo que se guarda es exactamente lo que está marcado.',
  'Nothing has been changed. Close and reopen to try again.':
    'No se cambió nada. Cierre y vuelva a abrir para intentarlo de nuevo.',
  'Accounts they can see': 'Cuentas que puede ver',
  '{n} of {total} selected · also what they may submit for':
    '{n} de {total} seleccionadas · también para las que puede enviar',
  'Showing every QuickBooks customer, including rows ruled not a practice.':
    'Se muestran todos los clientes de QuickBooks, incluidas las filas marcadas como «no es un consultorio».',
  '{n} QuickBooks customer is hidden — bank rows, suppliers and anything ruled not a practice.':
    '{n} cliente de QuickBooks está oculto: filas bancarias, proveedores y todo lo marcado como «no es un consultorio».',
  '{n} QuickBooks customers are hidden — bank rows, suppliers and anything ruled not a practice.':
    '{n} clientes de QuickBooks están ocultos: filas bancarias, proveedores y todo lo marcado como «no es un consultorio».',
  'Show practices only': 'Mostrar solo consultorios',
  'Show all': 'Mostrar todos',
  'No clinics yet — run Sync from QuickBooks first.':
    'Aún no hay clínicas: ejecute primero Sincronizar desde QuickBooks.',
  'Filter accounts': 'Filtrar cuentas',
  'Reps they can see': 'Representantes que puede ver',
  '{n} of {total} selected · ticking one also ticks their accounts above':
    '{n} de {total} seleccionados · al marcar uno también se marcan sus cuentas arriba',
  'No other sales reps yet.': 'Aún no hay otros representantes de ventas.',
  'Filter reps': 'Filtrar representantes',
  'Saving...': 'Guardando...',
  'Save access': 'Guardar acceso',
  // Server sentences behind PUT /admin/users/:id/clinics and /visible-reps
  'Rep visibility can only be set on a sales rep':
    'La visibilidad de representantes solo se puede establecer en un representante de ventas',
  'A rep is always able to see their own work - remove them from the list':
    'Un representante siempre puede ver su propio trabajo: quítelo de la lista',
  'One or more of those reps do not exist': 'Uno o más de esos representantes no existen',
  'Clinics can only be assigned to a sales_rep user':
    'Las clínicas solo se pueden asignar a un usuario sales_rep',
  'One or more clinic ids do not exist': 'Uno o más identificadores de clínica no existen',

  // Sales Representatives page
  'Sales Representatives': 'Representantes de ventas',
  'Manage registered sales representatives, their teams and their performance.':
    'Administre los representantes de ventas registrados, sus equipos y su desempeño.',
  Access: 'Acceso',
  Edit: 'Editar',
  'Sees {n} account': 'Ve {n} cuenta',
  'Sees {n} accounts': 'Ve {n} cuentas',
  '{n} other rep': '{n} otro representante',
  '{n} other reps': '{n} otros representantes',
  Orders: 'Pedidos',
  'IVR Request': 'Solicitudes de IVR',
  Practitioners: 'Proveedores',
  'Joined: {date}': 'Se unió: {date}',
  '+ Add User': '+ Agregar usuario',
  'No sales representatives found': 'No se encontraron representantes de ventas',

  // My Team page
  'My Team': 'Mi equipo',
  'Other reps whose work you can see.': 'Otros representantes cuyo trabajo puede ver.',
  'You can see the work of {reps} other rep, across {accounts} of their account. Their orders and IVRs are already included in your own lists.':
    'Puede ver el trabajo de {reps} otro representante, en {accounts} de sus cuentas. Sus pedidos e IVR ya están incluidos en sus propias listas.',
  'You can see the work of {reps} other rep, across {accounts} of their accounts. Their orders and IVRs are already included in your own lists.':
    'Puede ver el trabajo de {reps} otro representante, en {accounts} de sus cuentas. Sus pedidos e IVR ya están incluidos en sus propias listas.',
  'You can see the work of {reps} other reps, across {accounts} of their account. Their orders and IVRs are already included in your own lists.':
    'Puede ver el trabajo de {reps} otros representantes, en {accounts} de sus cuentas. Sus pedidos e IVR ya están incluidos en sus propias listas.',
  'You can see the work of {reps} other reps, across {accounts} of their accounts. Their orders and IVRs are already included in your own lists.':
    'Puede ver el trabajo de {reps} otros representantes, en {accounts} de sus cuentas. Sus pedidos e IVR ya están incluidos en sus propias listas.',
  'Could not load your team': 'No se pudo cargar su equipo',
  'No accounts assigned yet': 'Aún no hay cuentas asignadas',
  IVRs: 'IVR',
  'You have not been given access to any other reps':
    'No se le ha dado acceso a ningún otro representante',
  'An administrator grants this per person on the Sales Representatives page. Until then you see your own accounts and your own work only.':
    'Un administrador lo otorga por persona en la página Representantes de ventas. Hasta entonces, usted ve solo sus propias cuentas y su propio trabajo.',

  // StatusBadge priority label; same in both languages (listed in SAME_IN_BOTH in es.test.js).
  Normal: 'Normal',
};

export default people;
